import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { Button, LoaderXs, Panel, Tabs } from '@sketchnote/shared-components';
import * as React from 'react';
import { API, endpoints } from 'src/api';

const { useState, useRef, useEffect } = React;

export const UploadImageWithoutModal = ({
  onSubmit,
  isReadOnly = false,
  isOpen,
  onLoadingImage,
  onCancelFileUpload,
}: {
  onSubmit: (url: string) => void;
  isReadOnly?: boolean;
  isOpen?: boolean;
  onLoadingImage: (isLoading: boolean) => void;
  onCancelFileUpload: () => void;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      handleOnOpenDialog();
    }
  }, [isOpen]);

  const handleOnOpenDialog = () => {
    inputRef.current?.click();
  };

  const onUploadImage: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
    const files = e.target?.files?.[0];

    onLoadingImage(true);
    const data = new FormData();
    files && data.append('file', files);

    const fileURL = await API.put('/file', data, {
      headers: { ['Content-Type']: 'multipart/form-data' },
    });
    if (fileURL) {
      onSubmit(fileURL.data);
      onLoadingImage(false);
    }
  };

  return (
    <div>
      <input
        id="editor-image-upload"
        ref={inputRef}
        type="file"
        disabled={isReadOnly}
        accept="image/*"
        name="image"
        alt="upload image"
        hidden
        onChange={onUploadImage}
      />
    </div>
  );
};
